import { createContext, useContext, } from 'react';

export type ModalContentPropsBase = {
  close: () => void;
};

export type ModalConfig = {
  content: React.ReactNode | ((props: ModalContentPropsBase) => React.ReactNode);
  tailwindMaxWidthClass?: string;
  isMaxHeight?: boolean
};

export type ModalContextType = {
  showModal: (config: ModalConfig, modalKey?: string) => void;
  hideModal: () => void;
  isOpen: boolean;
  modalKey?: string;
};

export const GlobalModalContext = createContext<ModalContextType | undefined>(undefined);

export const useGlobalModal = () => {
  const context = useContext(GlobalModalContext);
  if (!context) throw new Error('useGlobalModal must be used inside GlobalModalProvider');
  return context;
};